import {
  RoleScope,
  RoleScopeUiVariant
} from '@features/team-management/types/customRoles';

const ORG_INFO_SCOPES: RoleScope[] = [
  RoleScope.ORGANISATION_ADMIN,
  RoleScope.OWNER,
  RoleScope.SUPER_ADMIN
];

const BRANCH_MULTI_SELECT_SCOPES: RoleScope[] = [
  RoleScope.BRANCH_ADMIN,
  RoleScope.FINANCE,
  RoleScope.EVENT_MANAGER,
  RoleScope.EVENT_VOLUNTEER
];

const GROUP_PICKER_SCOPES: RoleScope[] = [
  RoleScope.GROUP_ADMIN,
  RoleScope.ATTENDANCE_MANAGER,
  RoleScope.PAYMENT_MANAGER
];

const NONE_SCOPES: RoleScope[] = [
  RoleScope.SALES_MANAGER,
  RoleScope.SALES_AGENT,
  RoleScope.INDIVIDUAL,
  RoleScope.OPERATOR,
  RoleScope.BANK_ADMIN
];

const SCOPE_UI_MAP: Record<RoleScope, RoleScopeUiVariant> = {
  ...Object.fromEntries(
    ORG_INFO_SCOPES.map((scope) => [scope, 'org_info' as const])
  ),
  ...Object.fromEntries(
    BRANCH_MULTI_SELECT_SCOPES.map((scope) => [
      scope,
      'branch_multi_select' as const
    ])
  ),
  ...Object.fromEntries(
    GROUP_PICKER_SCOPES.map((scope) => [scope, 'group_picker' as const])
  ),
  ...Object.fromEntries(NONE_SCOPES.map((scope) => [scope, 'none' as const]))
} as Record<RoleScope, RoleScopeUiVariant>;

export const getScopeUiVariant = (scope: RoleScope): RoleScopeUiVariant =>
  SCOPE_UI_MAP[scope] ?? 'none';

export default getScopeUiVariant;
